module.exports = __webpack_public_path__ + "img/36136-058.22029e4e.jpg";